/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import restClient from './restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_VERSION_CARTSERVICE = '/v2';
const RESOURCE_PAGE_CARTSERVICE = '/cart';
const RESOURCE_PAGE_PAYMENT_ROUTE_CARTSERVICE = '/payment';
const RESOURCE_PAGE_PAYMENT_TOKEN_CARTSERVICE = '/clienttoken';

/**
 * paymentClientToken
 * url - /checkout/{apiversion}/cart/payment/clienttoken?paymentMethod={paymentMethod}&brand={brandId}
 *
 * @param {Object} args
 * @param {Object} args.env
 * @param {String} args.jwtToken
  * @param {String} args.paymentMethod
 */
const paymentClientToken = ({
    env, jwtToken, paymentMethod,
}) => {
    const envObj = env || {};
    envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}${RESOURCE_VERSION_CARTSERVICE}`;

    const payload = {
        paymentMethod,
    };

    // const resourcePage =  `${RESOURCE_PAGE_CARTSERVICE}${RESOURCE_PAGE_PAYMENT_ROUTE_CARTSERVICE}${RESOURCE_PAGE_PAYMENT_TOKEN_CARTSERVICE}?paymentMethod=${paymentMethod}`;
    const resourcePage =  `${RESOURCE_PAGE_CARTSERVICE}${RESOURCE_PAGE_PAYMENT_ROUTE_CARTSERVICE}${RESOURCE_PAGE_PAYMENT_TOKEN_CARTSERVICE}`;

    return restClient.getRequest(envObj, resourcePage, jwtToken, payload)
        .then((response) => response);
};

export default paymentClientToken;
